import React from 'react';
import { getIntl } from '../../../../../utils/intl';
import Text from '../../../../v2BaseComponents/Text';
import ListItem from '../../../../v2BaseComponents/ListItem';

const intl = getIntl('Activity-GuidanceContent', {
    header: "This is your go-to spot to quickly see what's happening.",
    bullet1Pretext: 'Track Real-Time Activity: ',
    bullet1: " See at a glance what's new or what has changed.",
    bullet2Pretext: 'Find Things Fast: ',
    bullet2: 'Use the profile filter and search to find specific changes or important notes.',
    bullet3Pretext: 'Share Notes: See Collaborator Activity: ',
    bullet3: '(Only if you add others) Know when someone checks out a profile.',
    subtext: 'Activity is your activity feed to keep history all in one place!',
});

export type GuidanceContentOwnProps = {};

export type GuidanceContentProps = GuidanceContentOwnProps;

const GuidanceContent: React.FC<GuidanceContentProps> = () => {
    return (
        <>
            {[
                {
                    pretext: intl('bullet1Pretext'),
                    text: intl('bullet1'),
                },
                {
                    pretext: intl('bullet2Pretext'),
                    text: intl('bullet2'),
                },
                {
                    pretext: intl('bullet3Pretext'),
                    text: intl('bullet3'),
                },
            ].map(({ pretext, text }) => (
                <ListItem unordered key={pretext} variant="body-1">
                    <Text variant="body-1">{pretext}</Text>
                    <Text variant="body-2">{text}</Text>
                </ListItem>
            ))}
            <Text variant="body-1">{intl('subtext')}</Text>
        </>
    );
};

export default React.memo(GuidanceContent);
